(function () {
  function parseProductJsonFromPage() {
    var el = document.querySelector('script[type="application/json"][data-tryon-page-product]');
    if (!el || !el.textContent || !String(el.textContent).trim()) {
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("[TryOn] Invalid product JSON in page.", e);
      return null;
    }
  }

  /** Strip HTML from product body; decode entities via DOM. */
  function htmlToPlainText(html) {
    if (html == null || html === "") {
      return "";
    }
    var s = String(html).trim();
    if (!s) {
      return "";
    }
    var tmp = document.createElement("div");
    tmp.innerHTML = s;
    var text = tmp.textContent || tmp.innerText || "";
    return text.replace(/\s+/g, " ").trim();
  }

  /** garment_description: plain-text description, type, tags (no title). */
  function buildGarmentDescriptionKeyValues(p) {
    if (!p || typeof p !== "object") {
      return {
        description: "",
        type: "",
        tags: []
      };
    }
    var descRaw = p.description != null ? p.description : p.body_html;
    var ptype = p.type != null ? p.type : p.product_type;
    var tags = p.tags;
    if (!Array.isArray(tags)) {
      tags = tags != null && String(tags).length ? [String(tags)] : [];
    }
    return {
      description: htmlToPlainText(descRaw),
      type: ptype != null ? String(ptype) : "",
      tags: tags
    };
  }

  function getGarmentDescriptionForApi() {
    var p = parseProductJsonFromPage();
    return buildGarmentDescriptionKeyValues(p);
  }

  function shopifyProductImageUrlAtWidth(url, width) {
    if (!url) {
      return "";
    }
    try {
      var parsed = new URL(url, window.location.href);
      parsed.searchParams.set("width", String(width));
      return parsed.href;
    } catch (e) {
      return url;
    }
  }

  function normalizeImageUrlPath(url) {
    if (!url) {
      return "";
    }
    try {
      return new URL(url, window.location.href).pathname;
    } catch (e2) {
      return String(url).split("?")[0];
    }
  }

  function garmentUrlFromMediaId(mediaId) {
    var product = parseProductJsonFromPage();
    if (!product || mediaId == null || mediaId === "") {
      return "";
    }
    var id = String(mediaId);
    var media = product.media || [];
    var i;
    var preview;
    var src;
    for (i = 0; i < media.length; i++) {
      if (String(media[i].id) === id) {
        preview = media[i].preview_image && media[i].preview_image.src;
        src = preview || media[i].src;
        if (src) {
          return shopifyProductImageUrlAtWidth(src, 1200);
        }
      }
    }
    var images = product.images || [];
    for (i = 0; i < images.length; i++) {
      if (String(images[i].id) === id && images[i].src) {
        return shopifyProductImageUrlAtWidth(images[i].src, 1200);
      }
    }
    return "";
  }

  function findMediaIdForImageSrc(imageSrc) {
    var product = parseProductJsonFromPage();
    if (!product || !imageSrc) {
      return "";
    }
    var needle = normalizeImageUrlPath(imageSrc);
    if (!needle) {
      return "";
    }
    var media = product.media || [];
    var i;
    var preview;
    var src;
    for (i = 0; i < media.length; i++) {
      preview = media[i].preview_image && media[i].preview_image.src;
      src = media[i].src || preview;
      if (src && (normalizeImageUrlPath(src) === needle || needle.indexOf(normalizeImageUrlPath(src)) !== -1)) {
        return String(media[i].id);
      }
    }
    return "";
  }

  function garmentUrlFromImageSrc(imageSrc) {
    if (!imageSrc) {
      return "";
    }
    var mediaId = findMediaIdForImageSrc(imageSrc);
    if (mediaId) {
      var fromId = garmentUrlFromMediaId(mediaId);
      if (fromId) {
        return fromId;
      }
    }
    return shopifyProductImageUrlAtWidth(imageSrc, 1200);
  }

  function garmentUrlFromTryOnGallerySlide(slide) {
    if (!slide) {
      return "";
    }
    var explicit = slide.getAttribute("data-tryon-garment-url");
    if (explicit) {
      return shopifyProductImageUrlAtWidth(explicit, 1200);
    }
    var mediaId =
      slide.getAttribute("data-media-id") ||
      (slide.querySelector("[data-js-product-gallery-image-id]")
        ? slide.querySelector("[data-js-product-gallery-image-id]").getAttribute("data-js-product-gallery-image-id")
        : "");
    if (mediaId) {
      var fromMedia = garmentUrlFromMediaId(mediaId);
      if (fromMedia) {
        return fromMedia;
      }
    }
    var fullLink = slide.querySelector("a[data-full]");
    if (fullLink) {
      var full = fullLink.getAttribute("data-full") || fullLink.getAttribute("href");
      if (full) {
        return shopifyProductImageUrlAtWidth(full, 1200);
      }
    }
    var img = slide.querySelector("img");
    if (img) {
      return garmentUrlFromImageSrc(img.currentSrc || img.src);
    }
    return "";
  }

  function getActiveGalleryGarmentUrlForTryon() {
    var gallery = document.querySelector("[data-js-product-gallery]");
    if (!gallery) {
      return "";
    }

    var trackedMediaId = gallery.getAttribute("data-tryon-active-media-id");
    if (trackedMediaId) {
      var trackedUrl = garmentUrlFromMediaId(trackedMediaId);
      if (trackedUrl) {
        return trackedUrl;
      }
    }

    var scope =
      gallery.closest("[data-js-product]") ||
      document.querySelector("[data-js-product]") ||
      document.querySelector(".template-product") ||
      document;

    var rondellImg = scope.querySelector(
      "a.rondell-item-focused img.rondell-item-image, .rondell-item-focused img.rondell-item-image"
    );
    if (rondellImg) {
      return garmentUrlFromImageSrc(rondellImg.currentSrc || rondellImg.src);
    }

    var activeFrame = gallery.querySelector(".fotorama__stage__frame.fotorama__active");
    if (activeFrame) {
      var slide = activeFrame.querySelector("[data-tryon-gallery-slide], .try-on-gallery-image");
      var slideUrl = garmentUrlFromTryOnGallerySlide(slide);
      if (slideUrl) {
        return slideUrl;
      }
      var frameImg = activeFrame.querySelector(".fotorama__img:not(.fotorama__img--full)");
      if (frameImg) {
        return garmentUrlFromImageSrc(frameImg.currentSrc || frameImg.src);
      }
    }

    return "";
  }

  function garmentUrlFromTryOnOpenButton(button) {
    if (!button || !button.closest) {
      return "";
    }
    var slide = button.closest("[data-tryon-gallery-slide], .try-on-gallery-image");
    if (slide) {
      return garmentUrlFromTryOnGallerySlide(slide);
    }
    return getActiveGalleryGarmentUrlForTryon();
  }

  /** Browser max JPEG quality for capture, watermark, and exported files. */
  var TRYON_JPEG_QUALITY = 1;
  var TRYON_DAILY_STATE_KEY = "ss_tryon_daily_state";
  var TRYON_LEGACY_STORAGE_KEYS = [
    "br_tryon_daily_state",
    "br_tryon_daily_generation",
    "br_tryon_successful_generation_count",
    "ss_tryon_daily_generation",
    "ss_tryon_successful_generation_count"
  ];

  function getLocalDateKey() {
    var d = new Date();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
  }

  function createFreshDailyState() {
    return {
      date: getLocalDateKey(),
      generationCount: 0,
      generationAttempts: 0,
      contactSubmitted: false,
      contact: null,
      sheetProductUrls: [],
      sheetProductTitles: []
    };
  }

  function clearTryOnDailyStorage() {
    var i;
    try {
      localStorage.removeItem(TRYON_DAILY_STATE_KEY);
      for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
        localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
      }
    } catch (e) {
      /* ignore */
    }
  }

  /** Drop yesterday's (or invalid) data — we only keep one small record for today. */
  function purgeStaleTryOnDailyStorage() {
    var today = getLocalDateKey();
    var i;
    try {
      for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
        localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
      }
      var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
      if (!raw) {
        return;
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.date !== today) {
        clearTryOnDailyStorage();
      }
    } catch (e) {
      clearTryOnDailyStorage();
    }
  }

  function readDailyState() {
    try {
      var today = getLocalDateKey();
      var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
      if (!raw) {
        return createFreshDailyState();
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.date !== today) {
        clearTryOnDailyStorage();
        return createFreshDailyState();
      }
      var genCount = parsed.generationCount;
      if (genCount == null && parsed.count != null) {
        genCount = parseInt(parsed.count, 10);
      } else {
        genCount = parseInt(genCount, 10);
      }
      if (isNaN(genCount) || genCount < 0) {
        genCount = 0;
      }
      var genAttempts = parseInt(parsed.generationAttempts, 10);
      if (isNaN(genAttempts) || genAttempts < 0) {
        genAttempts = genCount > 0 ? genCount : 0;
      }
      var contact = null;
      if (parsed.contact && typeof parsed.contact === "object") {
        contact = {
          name: parsed.contact.name != null ? String(parsed.contact.name) : "",
          countryCode:
            parsed.contact.countryCode != null ? String(parsed.contact.countryCode) : "",
          mobile: parsed.contact.mobile != null ? String(parsed.contact.mobile) : "",
          phone: parsed.contact.phone != null ? String(parsed.contact.phone) : "",
          phoneVerified: parsed.contact.phoneVerified === true,
          consent: parsed.contact.consent === true
        };
      }
      function asStringList(value) {
        if (!Array.isArray(value)) {
          return [];
        }
        return value
          .map(function (item) {
            return String(item || "").trim();
          })
          .filter(Boolean);
      }
      return {
        date: today,
        generationCount: genCount,
        generationAttempts: genAttempts,
        contactSubmitted: parsed.contactSubmitted === true,
        contact: contact,
        sheetProductUrls: asStringList(parsed.sheetProductUrls),
        sheetProductTitles: asStringList(parsed.sheetProductTitles)
      };
    } catch (e) {
      clearTryOnDailyStorage();
      return createFreshDailyState();
    }
  }

  function writeDailyState(state) {
    try {
      localStorage.setItem(TRYON_DAILY_STATE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
  }

  function incrementSuccessfulGenerationCount() {
    var state = readDailyState();
    state.generationCount = (state.generationCount || 0) + 1;
    writeDailyState(state);
  }

  function recordGenerationAttempt() {
    var state = readDailyState();
    state.generationAttempts = (state.generationAttempts || 0) + 1;
    writeDailyState(state);
  }

  function persistContactSubmitted(payload) {
    if (!payload) {
      return;
    }
    var state = readDailyState();
    state.contactSubmitted = true;
    state.contact = {
      name: payload.name,
      countryCode: payload.countryCode,
      mobile: payload.mobile,
      phone:
        payload.phone ||
        buildInternationalPhone(payload.countryCode, payload.mobile),
      phoneVerified: payload.phoneVerified === true,
      consent: !!payload.consent
    };
    writeDailyState(state);
  }

  function appendUniqueCsvItem(list, value) {
    var next = String(value || "").trim();
    if (!next) {
      return Array.isArray(list) ? list.slice() : [];
    }
    var out = Array.isArray(list) ? list.slice() : [];
    var lower = next.toLowerCase();
    var i;
    for (i = 0; i < out.length; i++) {
      if (String(out[i]).toLowerCase() === lower) {
        return out;
      }
    }
    out.push(next);
    return out;
  }

  /** Track products tried today; return comma-separated fields for the sheet. */
  function rememberSheetProducts(productUrl, productTitle) {
    var state = readDailyState();
    state.sheetProductUrls = appendUniqueCsvItem(state.sheetProductUrls, productUrl);
    state.sheetProductTitles = appendUniqueCsvItem(state.sheetProductTitles, productTitle);
    writeDailyState(state);
    return {
      productUrl: state.sheetProductUrls.join(", "),
      productTitle: state.sheetProductTitles.join(", ")
    };
  }

  var TRYON_PHONE_MIN_LEN = 7;
  var TRYON_PHONE_MAX_LEN = 15;

  function normalizeNationalPhoneDigits(value, maxLen) {
    return String(value || "")
      .replace(/\D/g, "")
      .slice(0, maxLen != null ? maxLen : TRYON_PHONE_MAX_LEN);
  }

  var TRYON_PINNED_COUNTRY_ISOS = ["ca", "us", "ae", "gb"];
  var TRYON_COUNTRY_LABELS = {
    ca: "+1 CA",
    us: "+1 US",
    ae: "+971 UAE",
    gb: "+44 UK"
  };

  function createTryOnPhoneOption(country, defaultIso) {
    var iso2 = String(country.iso2).toLowerCase();
    var option = document.createElement("option");
    option.value = iso2;
    option.setAttribute("data-dial-code", String(country.dialCode).replace(/\D/g, ""));
    option.setAttribute("data-iso", iso2.toUpperCase());
    option.textContent =
      TRYON_COUNTRY_LABELS[iso2] || "+" + country.dialCode + " " + iso2.toUpperCase();
    if (iso2 === defaultIso) {
      option.selected = true;
    }
    return option;
  }

  function populateTryOnPhoneCodeSelect(selectEl) {
    if (!selectEl || !window.intlTelInput || typeof window.intlTelInput.getCountryData !== "function") {
      return false;
    }

    var countries = window.intlTelInput.getCountryData();
    var defaultIso = String(selectEl.getAttribute("data-default-iso") || "CA").toLowerCase();
    var fragment = document.createDocumentFragment();
    var hasDefault = false;
    var usedIsos = {};
    var countryByIso = {};

    countries.forEach(function (country) {
      if (!country || !country.iso2 || !country.dialCode) {
        return;
      }
      countryByIso[String(country.iso2).toLowerCase()] = country;
    });

    TRYON_PINNED_COUNTRY_ISOS.forEach(function (iso2) {
      var country = countryByIso[iso2];
      if (!country) {
        return;
      }
      var option = createTryOnPhoneOption(country, defaultIso);
      if (option.selected) {
        hasDefault = true;
      }
      usedIsos[iso2] = true;
      fragment.appendChild(option);
    });

    var remaining = countries.filter(function (country) {
      if (!country || !country.iso2 || !country.dialCode) {
        return false;
      }
      return !usedIsos[String(country.iso2).toLowerCase()];
    });
    remaining.sort(function (a, b) {
      return String(a.name || a.iso2).localeCompare(String(b.name || b.iso2));
    });

    remaining.forEach(function (country) {
      var option = createTryOnPhoneOption(country, defaultIso);
      if (option.selected) {
        hasDefault = true;
      }
      fragment.appendChild(option);
    });

    selectEl.textContent = "";
    selectEl.appendChild(fragment);
    if (!hasDefault && selectEl.options.length) {
      selectEl.selectedIndex = 0;
    }
    return selectEl.options.length > 0;
  }

  function getTryOnDialCode(selectEl) {
    if (!selectEl) {
      return "";
    }
    var option = selectEl.options[selectEl.selectedIndex];
    if (option) {
      return String(option.getAttribute("data-dial-code") || "").replace(/\D/g, "");
    }
    return String(selectEl.value || "").replace(/\D/g, "");
  }

  function getTryOnCountryIso(selectEl) {
    if (!selectEl) {
      return "";
    }
    var option = selectEl.options[selectEl.selectedIndex];
    if (option) {
      return String(option.value || option.getAttribute("data-iso") || "").toLowerCase();
    }
    return "";
  }

  function buildInternationalPhone(dialCode, nationalDigits) {
    if (!dialCode || !nationalDigits) {
      return "";
    }
    return "+" + dialCode + nationalDigits;
  }

  function isValidInternationalPhone(dialCode, nationalDigits, countryIso) {
    if (!dialCode || !nationalDigits) {
      return false;
    }
    if (
      nationalDigits.length < TRYON_PHONE_MIN_LEN ||
      nationalDigits.length > TRYON_PHONE_MAX_LEN
    ) {
      return false;
    }
    if (
      window.intlTelInput &&
      window.intlTelInput.utils &&
      typeof window.intlTelInput.utils.isValidNumber === "function"
    ) {
      var fullNumber = buildInternationalPhone(dialCode, nationalDigits);
      return window.intlTelInput.utils.isValidNumber(
        fullNumber,
        String(countryIso || "").toLowerCase()
      );
    }
    return true;
  }

  function getTryOnPhoneValidationMessage(nationalDigits) {
    if (
      !nationalDigits ||
      nationalDigits.length < TRYON_PHONE_MIN_LEN ||
      nationalDigits.length > TRYON_PHONE_MAX_LEN
    ) {
      return (
        "Phone number must be between " +
        TRYON_PHONE_MIN_LEN +
        " and " +
        TRYON_PHONE_MAX_LEN +
        " digits."
      );
    }
    return "Please enter a valid mobile number for the selected country code.";
  }

  function resetTryOnPhoneCodeSelect(selectEl) {
    if (!selectEl) {
      return;
    }
    var defaultIso = String(selectEl.getAttribute("data-default-iso") || "CA").toLowerCase();
    var defaultOption = selectEl.querySelector('option[value="' + defaultIso + '"]');
    if (defaultOption) {
      selectEl.value = defaultIso;
      return;
    }
    selectEl.selectedIndex = 0;
  }

  /** Prefer exact API error text for user-facing status messages. */
  function extractTryonApiErrorMessage(payload, bodyText, httpStatus) {
    var fallback =
      httpStatus != null ? "Server request failed (" + httpStatus + ")." : "Try-on failed. Please retry.";

    if (payload && typeof payload === "object") {
      if (typeof payload.error === "string" && payload.error.trim()) {
        return payload.error.trim();
      }
      if (payload.error && typeof payload.error === "object") {
        if (typeof payload.error.message === "string" && payload.error.message.trim()) {
          return payload.error.message.trim();
        }
        if (typeof payload.error.detail === "string" && payload.error.detail.trim()) {
          return payload.error.detail.trim();
        }
      }
      if (typeof payload.message === "string" && payload.message.trim()) {
        return payload.message.trim();
      }
      if (typeof payload.detail === "string" && payload.detail.trim()) {
        return payload.detail.trim();
      }
      if (typeof payload.reason === "string" && payload.reason.trim()) {
        return payload.reason.trim();
      }
      if (Array.isArray(payload.errors) && payload.errors.length) {
        var parts = payload.errors
          .map(function (entry) {
            if (typeof entry === "string") {
              return entry.trim();
            }
            if (entry && typeof entry.message === "string") {
              return entry.message.trim();
            }
            if (entry && typeof entry.msg === "string") {
              return entry.msg.trim();
            }
            return "";
          })
          .filter(Boolean);
        if (parts.length) {
          return parts.join(" ");
        }
      }
    }

    if (bodyText && typeof bodyText === "string") {
      var trimmed = bodyText.trim();
      if (trimmed) {
        try {
          var parsed = JSON.parse(trimmed);
          var fromJson = extractTryonApiErrorMessage(parsed, "", httpStatus);
          if (fromJson && fromJson.indexOf("Server request failed") !== 0) {
            return fromJson;
          }
        } catch (e) {
          if (trimmed.length < 800 && trimmed.indexOf("<") !== 0) {
            return trimmed;
          }
        }
      }
    }

    return fallback;
  }

  purgeStaleTryOnDailyStorage();

  function initTryOn(root) {
    if (!root || root.dataset.tryonReady === "true") {
      return;
    }

    var modal = root.parentElement.querySelector("[data-tryon-modal]");
    if (!modal) {
      return;
    }

    var instanceId = root.getAttribute("data-tryon-instance");
    var openButtons;
    if (instanceId) {
      openButtons = document.querySelectorAll(
        '[data-tryon-instance="' + instanceId + '"][data-tryon-open]'
      );
    } else {
      openButtons = root.querySelectorAll("[data-tryon-open]");
    }
    var closeButtons = modal.querySelectorAll("[data-tryon-close]");
    var garmentImage = modal.querySelector("[data-tryon-garment]");
    var video = modal.querySelector("[data-tryon-video]");
    var canvas = modal.querySelector("[data-tryon-canvas]");
    var previewImage = modal.querySelector("[data-tryon-preview-image]");
    var resultImage = modal.querySelector("[data-tryon-result-image]");
    var uploadBox = modal.querySelector("[data-tryon-upload-trigger]");
    var cameraButton = modal.querySelector("[data-tryon-camera]");
    var chooseButton = modal.querySelector("[data-tryon-choose]");
    var fileInput = modal.querySelector("[data-tryon-file]");
    var statusNode = modal.querySelector("[data-tryon-status]");
    var loaderNode = modal.querySelector("[data-tryon-loader]");
    var loaderTextNode = modal.querySelector("[data-tryon-loader-text]");
    var cameraInstructionNode = modal.querySelector("[data-tryon-camera-instruction]");
    var cameraFlipButton = modal.querySelector("[data-tryon-camera-flip]");
    var captureButton = modal.querySelector("[data-tryon-capture]");
    var countdownNode = modal.querySelector("[data-tryon-countdown]");
    var downloadButton = modal.querySelector("[data-tryon-download]");
    var shareButton = modal.querySelector("[data-tryon-share]");
    var whatsappButton = modal.querySelector("[data-tryon-whatsapp]");
    var regenerateButton = modal.querySelector("[data-tryon-regenerate]");
    var detailsModal = modal.querySelector("[data-tryon-details-modal]");
    var detailsTitleEl = modal.querySelector("[data-tryon-details-title]");
    var detailsInnerDialog = modal.querySelector("[data-tryon-details-dialog]");
    var detailsNameInput = modal.querySelector("[data-tryon-customer-name]");
    var detailsPhoneInput = modal.querySelector("[data-tryon-customer-phone]");
    var detailsPhoneCodeSelect = modal.querySelector("[data-tryon-phone-code]");
    var detailsErrorNode = modal.querySelector("[data-tryon-details-error]");
    var detailsConsentInput = modal.querySelector("[data-tryon-consent]");
    var detailsSubmitButton = modal.querySelector("[data-tryon-details-submit]");
    var detailsCancelButton = modal.querySelector("[data-tryon-details-cancel]");
    var detailsStepDetails = modal.querySelector("[data-tryon-details-step-details]");
    var toolbarBusyEl = modal.querySelector("[data-tryon-toolbar-busy]");
    var toolbarBusyTextEl = modal.querySelector("[data-tryon-toolbar-busy-text]");

    var stream = null;
    var cameraFacingMode = "user";
    var isCameraCaptureInProgress = false;
    var currentState = "empty";
    var isLoading = false;
    var isToolbarActionBusy = false;
    var isDetailsSubmitBusy = false;
    var detailsSubmitLabel = "Submit";
    var loadingTextInterval = null;
    var lastSourceBlob = null;
    var generatedBlob = null;
    var generatedFilename = "try-on-result.jpg";
    var loadingMessages = [
      "Analyzing model pose...",
      "Analyzing garment details...",
      "Fitting garment on your photo...",
      "Rendering final try-on image..."
    ];
    var contextMenuBlocker = null;

    if (detailsPhoneCodeSelect) {
      if (!populateTryOnPhoneCodeSelect(detailsPhoneCodeSelect)) {
        console.warn("[TryOn] intl-tel-input country list could not be loaded.");
      }
    }

    if (detailsPhoneInput) {
      detailsPhoneInput.addEventListener("input", function () {
        var digits = normalizeNationalPhoneDigits(
          detailsPhoneInput.value,
          TRYON_PHONE_MAX_LEN
        );
        if (detailsPhoneInput.value !== digits) {
          detailsPhoneInput.value = digits;
        }
        setInputErrorState(detailsPhoneInput, false);
        if (detailsPhoneCodeSelect) {
          setInputErrorState(detailsPhoneCodeSelect, false);
        }
        if (detailsErrorNode && detailsErrorNode.textContent.indexOf("phone number") !== -1) {
          setDetailsError("");
        }
      });
      detailsPhoneInput.addEventListener("paste", function (event) {
        event.preventDefault();
        var pasted = "";
        try {
          pasted = (event.clipboardData || window.clipboardData).getData("text");
        } catch (e) {
          pasted = "";
        }
        detailsPhoneInput.value = normalizeNationalPhoneDigits(
          detailsPhoneInput.value + pasted,
          TRYON_PHONE_MAX_LEN
        );
      });
    }
    if (detailsPhoneCodeSelect) {
      detailsPhoneCodeSelect.addEventListener("change", function () {
        if (!detailsPhoneInput) {
          return;
        }
        detailsPhoneInput.value = normalizeNationalPhoneDigits(
          detailsPhoneInput.value,
          TRYON_PHONE_MAX_LEN
        );
        setInputErrorState(detailsPhoneCodeSelect, false);
        setInputErrorState(detailsPhoneInput, false);
        setDetailsError("");
      });
    }

    if (!openButtons.length || !uploadBox || !fileInput || !video || !canvas || !previewImage || !resultImage) {
      return;
    }

    /* Modal must live under document.body so position:fixed + z-index sit above .header-section (z-index:50).
       Nested inside product markup it can stack under the sticky header due to ancestor stacking contexts. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function setStatus(message, variant) {
      if (!statusNode) {
        return;
      }
      statusNode.textContent = message || "";
      statusNode.classList.toggle("ss-tryon-status--error", variant === "error");
    }

    function setCameraInstruction(message) {
      if (!cameraInstructionNode) {
        return;
      }
      cameraInstructionNode.textContent = message;
    }

    function setDetailsError(message) {
      if (detailsErrorNode) {
        detailsErrorNode.textContent = message || "";
      }
    }

    function getDetailsBusyLabel(actionLabel) {
      if (actionLabel === "generate") {
        return "Generating…";
      }
      if (actionLabel === "share") {
        return "Sharing…";
      }
      return "Downloading…";
    }

    function setDetailsSubmitBusy(busy, busyText) {
      isDetailsSubmitBusy = busy;
      if (detailsModal) {
        detailsModal.setAttribute("data-submit-busy", busy ? "true" : "false");
      }
      if (detailsSubmitButton) {
        detailsSubmitButton.disabled = busy;
        detailsSubmitButton.classList.toggle("is-busy", busy);
        detailsSubmitButton.setAttribute("aria-busy", busy ? "true" : "false");
        detailsSubmitButton.textContent = busy ? busyText || "Please wait…" : detailsSubmitLabel;
      }
      if (detailsCancelButton) {
        detailsCancelButton.disabled = busy;
      }
      if (detailsNameInput) {
        detailsNameInput.disabled = busy;
      }
      if (detailsPhoneInput) {
        detailsPhoneInput.disabled = busy;
      }
      if (detailsPhoneCodeSelect) {
        detailsPhoneCodeSelect.disabled = busy;
      }
      if (detailsConsentInput) {
        detailsConsentInput.disabled = busy;
      }
    }

    function setInputErrorState(input, hasError) {
      if (!input) {
        return;
      }
      input.classList.toggle("ss-tryon-input-error", !!hasError);
    }

    function setUploadState(state) {
      currentState = state;
      uploadBox.setAttribute("data-state", state);
    }

    function setCountdownValue(value) {
      if (!countdownNode) {
        return;
      }
      if (value) {
        countdownNode.textContent = String(value);
        uploadBox.setAttribute("data-countdown-active", "true");
      } else {
        countdownNode.textContent = "";
        uploadBox.setAttribute("data-countdown-active", "false");
      }
    }

    function setLoading(value, fixedMessage) {
      isLoading = value;
      uploadBox.setAttribute("data-loading", value ? "true" : "false");
      if (loaderNode) {
        loaderNode.setAttribute("aria-hidden", value ? "false" : "true");
      }

      if (loadingTextInterval) {
        clearInterval(loadingTextInterval);
        loadingTextInterval = null;
      }
      if (!loaderTextNode) {
        return;
      }

      if (value) {
        if (fixedMessage) {
          loaderTextNode.textContent = fixedMessage;
        } else {
          var messageIndex = 0;
          loaderTextNode.textContent = loadingMessages[messageIndex];
          loadingTextInterval = setInterval(function () {
            messageIndex = (messageIndex + 1) % loadingMessages.length;
            loaderTextNode.textContent = loadingMessages[messageIndex];
          }, 1400);
        }
      } else {
        loaderTextNode.textContent = loadingMessages[0];
      }
    }

    function setToolbarActionLoading(active, message) {
      isToolbarActionBusy = !!active;
      uploadBox.setAttribute("data-toolbar-busy", active ? "true" : "false");
      if (toolbarBusyEl) {
        if (active) {
          toolbarBusyEl.removeAttribute("hidden");
        } else {
          toolbarBusyEl.setAttribute("hidden", "");
        }
      }
      if (toolbarBusyTextEl) {
        toolbarBusyTextEl.textContent = active && message ? message : "";
      }
    }

    function nextPaint() {
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      });
    }

    /** Live store URL from Liquid (shop.url); used when theme dev serves images on localhost. */
    function getTryonStoreOrigin() {
      var origin = (modal.dataset.tryonStoreOrigin || "").trim().replace(/\/$/, "");
      if (origin) {
        return origin;
      }
      if (window.Shopify && Shopify.shop) {
        return "https://" + String(Shopify.shop).replace(/\/$/, "");
      }
      return "";
    }

    function toApiAccessibleGarmentUrl(url) {
      if (!url || typeof url !== "string") {
        return "";
      }
      var trimmed = url.trim();
      if (!trimmed) {
        return "";
      }
      try {
        var parsed = new URL(trimmed, window.location.href);
        if (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost") {
          var storeOrigin = getTryonStoreOrigin();
          if (storeOrigin) {
            return storeOrigin + parsed.pathname + parsed.search;
          }
        }
        return parsed.href;
      } catch (e) {
        return trimmed;
      }
    }

    function getActiveGarmentUrl(fromButton) {
      if (modal.dataset.tryonUseTestGarment === "true") {
        return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
      }

      if (fromButton) {
        var fromTrigger = garmentUrlFromTryOnOpenButton(fromButton);
        if (fromTrigger) {
          return toApiAccessibleGarmentUrl(fromTrigger);
        }
      }

      var galleryGarment = getActiveGalleryGarmentUrlForTryon();
      if (galleryGarment) {
        return toApiAccessibleGarmentUrl(galleryGarment);
      }

      var detailRoot =
        document.querySelector(".product-single[data-section-type='product-template']") ||
        document.querySelector(".product-single") ||
        document.querySelector("[data-js-product]") ||
        document.querySelector(".product-page-main") ||
        document.querySelector(".template-product") ||
        document.querySelector("#MainContent") ||
        document.querySelector("[data-product]");
      if (!detailRoot) {
        return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
      }

      function imageUrlFrom(node) {
        if (!node) {
          return "";
        }
        return node.currentSrc || node.src || "";
      }

      function imageFromSlide(slide) {
        if (!slide) {
          return "";
        }
        var imageNode =
          slide.querySelector(".product-single__media-image img") ||
          slide.querySelector("img");
        return imageUrlFrom(imageNode);
      }

      // 0) Image visibly centered in the main stage: PM Slider app gallery, else Belle's
      //    per-color slick sliders (shifted with translateX).
      var stages = [
        { root: ".pmslider-own--slides", images: ["img"] },
        { root: ".prod-large-img", images: [".primgSlider .slick-current img", ".product-single__photo img"] },
        {
          root: "[data-js-product-gallery-main] .fotorama__stage",
          images: [".fotorama__active img", "img"]
        },
        {
          root: ".rio-media-gallery",
          images: ["[id^='pwzrswiper-img'] img", ".rio-hide-scrollbar img", "img"]
        }
      ];
      for (var g = 0; g < stages.length; g++) {
        var stage = detailRoot.querySelector(stages[g].root);
        if (!stage) {
          continue;
        }
        var stageRect = stage.getBoundingClientRect();
        if (!stageRect.width) {
          continue;
        }
        for (var s = 0; s < stages[g].images.length; s++) {
          var stageImages = stage.querySelectorAll(stages[g].images[s]);
          for (var k = 0; k < stageImages.length; k++) {
            var rect = stageImages[k].getBoundingClientRect();
            var centerX = rect.left + rect.width / 2;
            if (rect.width > 0 && centerX >= stageRect.left && centerX <= stageRect.right) {
              var stageUrl = imageUrlFrom(stageImages[k]);
              if (stageUrl) {
                return toApiAccessibleGarmentUrl(stageUrl);
              }
            }
          }
        }
      }

      // 1) Flickity active slide.
      var selectedSlide = detailRoot.querySelector(".product-images__slide.is-selected");
      var selectedUrl = imageFromSlide(selectedSlide);
      if (selectedUrl) {
        return toApiAccessibleGarmentUrl(selectedUrl);
      }

      // 2) Theme active slide state.
      var activeSlide = detailRoot.querySelector(".product-images__slide.is-active");
      var activeUrl = imageFromSlide(activeSlide);
      if (activeUrl) {
        return toApiAccessibleGarmentUrl(activeUrl);
      }

      // 3) Active thumbnail mapped to corresponding slide id.
      var activeThumb = detailRoot.querySelector(".product-thumbnail.is-active, .product-thumbnail.is-initial-selected");
      if (activeThumb && activeThumb.id && activeThumb.id.indexOf("Thumb-") === 0) {
        var mappedSlide = detailRoot.querySelector("#" + activeThumb.id.replace("Thumb-", "Slide-"));
        var mappedUrl = imageFromSlide(mappedSlide);
        if (mappedUrl) {
          return toApiAccessibleGarmentUrl(mappedUrl);
        }
      }

      // 4) Final fallback to first gallery image.
      var fallbackImage = detailRoot.querySelector(".product-images img");
      return toApiAccessibleGarmentUrl(
        imageUrlFrom(fallbackImage) || modal.dataset.defaultGarment || ""
      );
    }

    function syncGarmentImage(fromButton) {
      var garmentUrl = getActiveGarmentUrl(fromButton);
      if (garmentUrl && garmentImage) {
        garmentImage.src = garmentUrl;
      }
      return garmentUrl;
    }

    function applyVariantToTryOn(variant) {
      if (!variant || !modal) {
        return;
      }
      if (variant.id != null) {
        modal.setAttribute("data-tryon-variant-id", String(variant.id));
      }
      var variantTitle = variant.name || variant.title || "";
      if (variantTitle) {
        modal.setAttribute("data-tryon-variant-title", variantTitle);
      }
      var productPath = String(modal.dataset.tryonProductPath || "").trim();
      if (!productPath) {
        productPath = window.location.pathname;
      }
      var storeOrigin = getTryonStoreOrigin() || String(modal.dataset.tryonWebsiteUrl || "").replace(/\/$/, "");
      if (variant.id != null && storeOrigin) {
        modal.dataset.tryonProductUrl =
          storeOrigin + productPath + (productPath.indexOf("?") === -1 ? "?" : "&") + "variant=" + variant.id;
      }
      var featured =
        (variant.featured_image && (variant.featured_image.src || variant.featured_image)) ||
        (variant.featured_media &&
          variant.featured_media.preview_image &&
          (variant.featured_media.preview_image.src || variant.featured_media.preview_image));
      if (featured && typeof featured === "string" && garmentImage) {
        var nextUrl = toApiAccessibleGarmentUrl(featured);
        if (nextUrl) {
          modal.dataset.defaultGarment = nextUrl;
          garmentImage.src = nextUrl;
        }
      }
    }

    function getSelectedVariantIdFromForm() {
      var input =
        document.querySelector('.product-single [data-product-form] [name="id"]') ||
        document.querySelector('.product-single form [name="id"]') ||
        document.querySelector('[data-product-form] [name="id"]');
      if (input && input.value) {
        return input.value;
      }
      return modal.getAttribute("data-tryon-variant-id") || "";
    }

    function getCameraVideoConstraints() {
      if (cameraFacingMode === "environment") {
        return {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        };
      }
      return {
        facingMode: "user",
        aspectRatio: { ideal: 4 / 5 },
        width: { ideal: 864 },
        height: { ideal: 1080 }
      };
    }

    async function attachLiveCameraStream() {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: getCameraVideoConstraints()
        });
      } catch (firstErr) {
        if (cameraFacingMode === "environment") {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { ideal: "environment" } }
          });
        } else {
          throw firstErr;
        }
      }
      video.srcObject = stream;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.muted = true;
      await video.play();
    }

    function stopCamera() {
      isCameraCaptureInProgress = false;
      setCountdownValue("");
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
        stream = null;
      }
      if (video) {
        video.srcObject = null;
      }
    }

    function getCaptureCrop(videoWidth, videoHeight) {
      var targetRatio = 4 / 5;
      var cropWidth = videoWidth;
      var cropHeight = videoHeight;

      if (videoWidth / videoHeight > targetRatio) {
        cropWidth = videoHeight * targetRatio;
      } else {
        cropHeight = videoWidth / targetRatio;
      }

      var cropX = (videoWidth - cropWidth) / 2;
      var cropY = (videoHeight - cropHeight) / 2;

      return {
        sx: cropX,
        sy: cropY,
        sw: cropWidth,
        sh: cropHeight
      };
    }

    function getTargetCaptureSize() {
      var targetHeight = 1250;
      var targetWidth = Math.round((targetHeight * 4) / 5);
      return {
        width: targetWidth,
        height: targetHeight
      };
    }

    async function blobToDataUrl(fileBlob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result || "");
        };
        reader.onerror = function () {
          reject(new Error("Failed to read image."));
        };
        reader.readAsDataURL(fileBlob);
      });
    }

    function stripDataUrlToRawBase64(dataUrl) {
      if (!dataUrl || typeof dataUrl !== "string") {
        return "";
      }
      var trimmed = dataUrl.trim();
      var marker = "base64,";
      var idx = trimmed.indexOf(marker);
      if (idx !== -1) {
        return trimmed.slice(idx + marker.length);
      }
      return trimmed;
    }

    function canvasToJpegBlob(canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(
          function (blob) {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Could not encode JPEG."));
            }
          },
          "image/jpeg",
          TRYON_JPEG_QUALITY
        );
      });
    }

    async function blobToJpegBase64(fileBlob) {
      var jpegBlob = fileBlob;
      var type = (fileBlob && fileBlob.type) || "";
      if (type.indexOf("jpeg") === -1 && type.indexOf("jpg") === -1) {
        var sourceUrl = URL.createObjectURL(fileBlob);
        try {
          var sourceImage = await imageFromUrl(sourceUrl);
          var tempCanvas = document.createElement("canvas");
          tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
          tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
          tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
          jpegBlob = await canvasToJpegBlob(tempCanvas);
        } finally {
          URL.revokeObjectURL(sourceUrl);
        }
      }
      var dataUrl = await blobToDataUrl(jpegBlob);
      return {
        base64: stripDataUrlToRawBase64(dataUrl),
        mimeType: "image/jpeg"
      };
    }

    async function imageUrlToJpegBase64(imageUrl) {
      var sourceImage;
      try {
        sourceImage = await imageFromUrl(imageUrl, true);
      } catch (corsErr) {
        sourceImage = await imageFromUrl(imageUrl, false);
      }
      var tempCanvas = document.createElement("canvas");
      tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
      tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
      tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
      var jpegBlob = await canvasToJpegBlob(tempCanvas);
      var dataUrl = await blobToDataUrl(jpegBlob);
      return {
        base64: stripDataUrlToRawBase64(dataUrl),
        mimeType: "image/jpeg"
      };
    }

    function findDecodableImageFromJson(node, depth) {
      depth = depth || 0;
      if (!node || depth > 12) {
        return null;
      }
      if (typeof node === "string") {
        try {
          var blob = dataUrlToBlob(node);
          return blob && blob.size > 0 ? blob : null;
        } catch (decodeErr) {
          return null;
        }
      }
      if (Array.isArray(node)) {
        var i;
        for (i = 0; i < node.length; i++) {
          var fromArray = findDecodableImageFromJson(node[i], depth + 1);
          if (fromArray) {
            return fromArray;
          }
        }
        return null;
      }
      if (typeof node !== "object") {
        return null;
      }
      var preferredKeys = [
        "resultImageBase64",
        "result_image_base64",
        "image",
        "result_image",
        "image_base64",
        "result",
        "output",
        "data",
        "url",
        "image_url",
        "result_url"
      ];
      var k;
      for (k = 0; k < preferredKeys.length; k++) {
        if (node[preferredKeys[k]] != null) {
          var fromKey = findDecodableImageFromJson(node[preferredKeys[k]], depth + 1);
          if (fromKey) {
            return fromKey;
          }
        }
      }
      for (var key in node) {
        if (Object.prototype.hasOwnProperty.call(node, key)) {
          var nested = findDecodableImageFromJson(node[key], depth + 1);
          if (nested) {
            return nested;
          }
        }
      }
      return null;
    }

    function rawBase64ToBlob(base64, mimeType) {
      if (!base64 || typeof base64 !== "string") {
        return null;
      }
      var normalized = base64.trim();
      if (!normalized) {
        return null;
      }
      if (normalized.indexOf("data:") === 0) {
        return dataUrlToBlob(normalized);
      }
      var mime = mimeType && typeof mimeType === "string" ? mimeType.trim() : "image/png";
      return dataUrlToBlob("data:" + mime + ";base64," + normalized);
    }

    async function parseTryonSuccessResponse(response) {
      var contentType = (response.headers.get("Content-Type") || "").toLowerCase();
      if (contentType.indexOf("image/") !== -1) {
        return response.blob();
      }
      var bodyText = await response.text();
      var data = null;
      try {
        data = JSON.parse(bodyText);
      } catch (parseErr) {
        throw new Error("Try-on API returned a non-image, non-JSON response.");
      }
      if (data && data.success === false) {
        throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
      }
      if (data && typeof data.resultImageBase64 === "string" && data.resultImageBase64.trim()) {
        var resultBlob = rawBase64ToBlob(data.resultImageBase64, data.mimeType);
        if (resultBlob && resultBlob.size > 0) {
          return resultBlob;
        }
        throw new Error("Try-on API returned an invalid result image.");
      }
      var blob = findDecodableImageFromJson(data);
      if (blob) {
        return blob;
      }
      var urlCandidate =
        data &&
        (data.result_url ||
          data.image_url ||
          data.url ||
          (data.output && (data.output.url || data.output.result_url)));
      if (urlCandidate && typeof urlCandidate === "string") {
        return urlToBlob(urlCandidate);
      }
      throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
    }

    async function urlToBlob(imageUrl) {
      var response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error("Could not load generated image.");
      }
      return response.blob();
    }

    function dataUrlToBlob(value) {
      if (!value || typeof value !== "string") {
        return null;
      }

      var normalized = value.trim();
      if (!normalized) {
        return null;
      }

      // Support both full data URLs and raw base64 payloads.
      if (normalized.indexOf("data:") !== 0) {
        normalized = "data:image/jpeg;base64," + normalized;
      }

      var parts = normalized.split(",");
      if (parts.length < 2) {
        return null;
      }

      var header = parts[0];
      var base64 = parts.slice(1).join(",");
      var mimeMatch = header.match(/data:(.*?);base64/);
      var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : "image/jpeg";
      var binary = atob(base64);
      var length = binary.length;
      var bytes = new Uint8Array(length);

      for (var i = 0; i < length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
      }

      return new Blob([bytes], { type: mimeType });
    }

    async function imageFromUrl(imageUrl, useCrossOrigin) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        if (useCrossOrigin) {
          image.crossOrigin = "anonymous";
        }
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          reject(new Error("Failed to decode image."));
        };
        image.src = imageUrl;
      });
    }

    var watermarkLogoPromise = null;

    function loadWatermarkLogo() {
      if (watermarkLogoPromise) return watermarkLogoPromise;
      var watermarkUrl = (modal.dataset.tryonWatermarkUrl || "").trim();
      if (!watermarkUrl) {
        watermarkLogoPromise = Promise.resolve(null);
        return watermarkLogoPromise;
      }
      watermarkLogoPromise = new Promise(function (resolve) {
        var logo = new Image();
        logo.crossOrigin = "anonymous";
        logo.onload = function () {
          resolve(logo);
        };
        logo.onerror = function () {
          console.error("[TryOn] Failed to load watermark logo:", watermarkUrl);
          resolve(null);
        };
        logo.src = watermarkUrl;
      });
      return watermarkLogoPromise;
    }

    async function applyWatermark(inputBlob) {
      try {
        var sourceUrl = URL.createObjectURL(inputBlob);
        var sourceImage = await imageFromUrl(sourceUrl);
        URL.revokeObjectURL(sourceUrl);

        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = sourceImage.width;
        tempCanvas.height = sourceImage.height;
        var ctx = tempCanvas.getContext("2d");
        ctx.drawImage(sourceImage, 0, 0, sourceImage.width, sourceImage.height);

        var logo = await loadWatermarkLogo();
        if (logo && logo.width && logo.height) {
          var targetWidth = Math.max(80, Math.round(sourceImage.width * 0.5));
          var scale = targetWidth / logo.width;
          var targetHeight = Math.round(logo.height * scale);
          ctx.save();
          ctx.translate(sourceImage.width / 2, sourceImage.height / 2);
          ctx.rotate((-12 * Math.PI) / 180);
          ctx.globalAlpha = 0.28;
          ctx.drawImage(
            logo,
            -targetWidth / 2,
            -targetHeight / 2,
            targetWidth,
            targetHeight
          );
          ctx.restore();
        }

        var finalBlob = await new Promise(function (resolve) {
          tempCanvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
        });
        if (!finalBlob) {
          console.warn("[TryOn] Canvas toBlob returned null. Returning original image.");
        }
        return finalBlob || inputBlob;
      } catch (error) {
        console.error("[TryOn] Watermark apply failed.", error);
        return inputBlob;
      }
    }

    function collectValidatedDetailsPayload() {
      var name = (detailsNameInput.value || "").trim();
      var dialCode = getTryOnDialCode(detailsPhoneCodeSelect);
      var countryIso = getTryOnCountryIso(detailsPhoneCodeSelect);
      var nationalPhone = normalizeNationalPhoneDigits(
        detailsPhoneInput.value,
        TRYON_PHONE_MAX_LEN
      );
      detailsPhoneInput.value = nationalPhone;
      var phone = buildInternationalPhone(dialCode, nationalPhone);
      var missingName = !name;
      var missingPhone = !nationalPhone;
      var invalidPhone = !isValidInternationalPhone(dialCode, nationalPhone, countryIso);
      var consentGiven = detailsConsentInput && detailsConsentInput.checked;

      setInputErrorState(detailsNameInput, missingName);
      setInputErrorState(detailsPhoneInput, missingPhone || invalidPhone);
      if (detailsPhoneCodeSelect) {
        setInputErrorState(detailsPhoneCodeSelect, missingPhone || invalidPhone);
      }

      if (!name || !nationalPhone) {
        setDetailsError("Please enter both name and mobile number.");
        return null;
      }
      if (invalidPhone) {
        setDetailsError(getTryOnPhoneValidationMessage(nationalPhone));
        return null;
      }
      if (!consentGiven) {
        setInputErrorState(detailsConsentInput, true);
        setDetailsError("Please give consent for Chique to contact you.");
        return null;
      }
      setInputErrorState(detailsConsentInput, false);
      setDetailsError("");
      return {
        name: name,
        countryCode: dialCode,
        mobile: nationalPhone,
        phone: phone,
        consent: !!consentGiven
      };
    }

    async function submitCustomerDetails(payload) {
      var url = modal.dataset.detailsEndpoint;
      if (!url || !payload) {
        console.warn("[TryOn] Sheet submit skipped: missing endpoint or payload.", { url: !!url, payload: !!payload });
        return;
      }
      var dialCode = String(payload.countryCode || "").replace(/\D/g, "");
      var websiteUrl = String(
        payload.websiteUrl ||
          modal.dataset.tryonWebsiteUrl ||
          modal.dataset.tryonStoreOrigin ||
          ""
      )
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(payload.productUrl || modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var productTitle = String(payload.productTitle || modal.dataset.tryonProductTitle || "").trim();
      var sheetProducts = rememberSheetProducts(productUrl, productTitle);
      var bodyObj = {
        name: payload.name,
        countryCode: dialCode ? "+" + dialCode : "",
        phone: payload.mobile || "",
        consent: !!payload.consent,
        phoneVerified: payload.phoneVerified === true,
        websiteUrl: websiteUrl,
        productUrl: sheetProducts.productUrl,
        productTitle: sheetProducts.productTitle
      };
      console.info("[TryOn] Sheet submit →", url, bodyObj);
      var response = await fetch(url, {
        method: "POST",
        redirect: "follow",
        cache: "no-store",
        headers: {
          "Content-Type": "text/plain;charset=utf-8"
        },
        body: JSON.stringify(bodyObj)
      });
      var rawText = "";
      try {
        rawText = await response.text();
      } catch (readErr) {
        rawText = "";
      }
      var data = null;
      if (rawText) {
        try {
          data = JSON.parse(rawText);
        } catch (parseErr) {
          data = null;
        }
      }
      var isSuccess = data && (data.ok === true || data.success === true);
      if (isSuccess) {
        console.info("[TryOn] Sheet saved:", data);
        return;
      }
      if (rawText && /<!DOCTYPE html/i.test(rawText)) {
        console.warn(
          "[TryOn] Sheet redirect returned Google's file page instead of JSON. The row can still be saved."
        );
        return;
      }
      throw new Error((data && data.error) || "Could not save details to sheet.");
    }

    async function completeVerifiedSubmission(payload) {
      var websiteUrl = String(modal.dataset.tryonWebsiteUrl || modal.dataset.tryonStoreOrigin || "")
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var enriched = {
        name: payload.name,
        countryCode: payload.countryCode,
        mobile: payload.mobile,
        phone: payload.phone,
        consent: !!payload.consent,
        phoneVerified: false,
        websiteUrl: websiteUrl,
        productUrl: productUrl,
        productTitle: String(modal.dataset.tryonProductTitle || "").trim()
      };
      persistContactSubmitted(enriched);
      await submitCustomerDetails(enriched);
    }

    /** Re-send contact on later same-day try-ons so Apps Script can upsert products (comma-separated). */
    function submitStoredContactForCurrentProduct() {
      var state = readDailyState();
      if (!state.contactSubmitted || !state.contact) {
        return Promise.resolve();
      }
      var contact = state.contact;
      var websiteUrl = String(modal.dataset.tryonWebsiteUrl || modal.dataset.tryonStoreOrigin || "")
        .trim()
        .replace(/\/$/, "");
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      return submitCustomerDetails({
        name: contact.name,
        countryCode: contact.countryCode,
        mobile: contact.mobile,
        phone:
          contact.phone ||
          buildInternationalPhone(contact.countryCode, contact.mobile),
        consent: contact.consent === true,
        phoneVerified: false,
        websiteUrl: websiteUrl,
        productUrl: productUrl,
        productTitle: String(modal.dataset.tryonProductTitle || "").trim()
      });
    }

    function downloadBlob(blob, filename) {
      var fileUrl = URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = filename || "try-on-result.jpg";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(fileUrl);
    }

    function askCustomerDetails(actionLabel) {
      if (!detailsModal || !detailsNameInput || !detailsPhoneInput || !detailsSubmitButton || !detailsCancelButton) {
        return Promise.resolve(null);
      }

      return new Promise(function (resolve) {
        function consentChangeHandler() {
          if (detailsConsentInput && detailsConsentInput.checked) {
            setInputErrorState(detailsConsentInput, false);
            if (
              detailsErrorNode &&
              detailsErrorNode.textContent ===
                "Please give consent for Chique to contact you."
            ) {
              setDetailsError("");
            }
          }
        }

        function cleanupListeners() {
          detailsSubmitButton.removeEventListener("click", submitHandler);
          detailsCancelButton.removeEventListener("click", cancelHandler);
          detailsModal.removeEventListener("click", overlayHandler);
          if (detailsConsentInput) {
            detailsConsentInput.removeEventListener("change", consentChangeHandler);
          }
        }

        function closePopup(result) {
          cleanupListeners();
          setDetailsSubmitBusy(false);
          detailsModal.hidden = true;
          modal.classList.remove("ss-tryon-modal--details-open");
          resolve(result);
        }

        async function submitHandler() {
          if (isDetailsSubmitBusy) {
            return;
          }
          var payload = collectValidatedDetailsPayload();
          if (!payload) {
            return;
          }
          if (!modal.dataset.detailsEndpoint) {
            setDetailsError("Sheet endpoint is not configured.");
            return;
          }
          setDetailsSubmitBusy(true, "Saving…");
          try {
            await completeVerifiedSubmission(payload);
            closePopup(payload);
          } catch (error) {
            setDetailsSubmitBusy(false);
            setDetailsError((error && error.message) || "Could not save details.");
          }
        }

        function cancelHandler() {
          if (isDetailsSubmitBusy) {
            return;
          }
          closePopup(null);
        }

        function overlayHandler(event) {
          if (event.target === detailsModal) {
            if (isDetailsSubmitBusy) {
              return;
            }
            closePopup(null);
          }
        }

        detailsNameInput.value = "";
        detailsPhoneInput.value = "";
        resetTryOnPhoneCodeSelect(detailsPhoneCodeSelect);
        if (detailsConsentInput) {
          detailsConsentInput.checked = false;
        }
        setInputErrorState(detailsNameInput, false);
        setInputErrorState(detailsPhoneInput, false);
        if (detailsPhoneCodeSelect) {
          setInputErrorState(detailsPhoneCodeSelect, false);
        }
        setInputErrorState(detailsConsentInput, false);
        setDetailsError("");
        setDetailsSubmitBusy(false);
        detailsSubmitLabel = "Submit";
        if (detailsSubmitButton) {
          detailsSubmitButton.textContent = "Submit";
        }
        if (detailsConsentInput) {
          detailsConsentInput.addEventListener("change", consentChangeHandler);
        }
        var headline = "Share your details for another try-on";
        if (actionLabel === "download" || actionLabel === "share") {
          headline = "Share your details to download or share";
        }
        if (detailsTitleEl) {
          detailsTitleEl.textContent = headline;
        }
        if (detailsInnerDialog) {
          detailsInnerDialog.setAttribute("aria-label", headline);
        }
        detailsModal.hidden = false;
        modal.classList.add("ss-tryon-modal--details-open");
        detailsModal.addEventListener("click", overlayHandler);
        detailsSubmitButton.addEventListener("click", submitHandler);
        detailsCancelButton.addEventListener("click", cancelHandler);
        setStatus("Enter your details to continue.");
        detailsNameInput.focus();
      });
    }

    async function handleDownload() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }
      var contactOk = await ensureContactForExport("download");
      if (!contactOk) {
        return;
      }
      setToolbarActionLoading(true, "Downloading…");
      setStatus("");
      try {
        await nextPaint();
        downloadBlob(generatedBlob, generatedFilename);
        setStatus("Downloaded.");
      } catch (err) {
        setStatus("Download failed.", "error");
        console.error("[TryOn] Download error:", err);
      } finally {
        setToolbarActionLoading(false);
      }
    }

    function buildWhatsAppSupportUrl() {
      var phone = String(modal.dataset.tryonWhatsappPhone || "").replace(/\D/g, "");
      if (!phone) {
        var legacyUrl = String(modal.dataset.tryonWhatsappUrl || "").trim();
        var phoneMatch = legacyUrl.match(/phone=(\d+)/);
        if (phoneMatch) {
          phone = phoneMatch[1];
        }
      }
      if (!phone) {
        return "";
      }
      var productTitle = String(modal.dataset.tryonProductTitle || "").trim() || "this product";
      var productUrl = String(modal.dataset.tryonProductUrl || "").trim();
      if (!productUrl) {
        productUrl = window.location.href.split("#")[0];
      }
      var message =
        "Hi Team,\n\n" +
        "I need assistance regarding the " +
        productTitle +
        " available on your website:\n\n" +
        productUrl +
        "\n\n" +
        "Could you please provide details about its availability, customization options, delivery timeline, and sizing assistance? I would also appreciate any additional information that may help me place an order.\n\n" +
        "Thank you, and I look forward to your response.";
      return (
        "https://api.whatsapp.com/send/?phone=" +
        encodeURIComponent(phone) +
        "&text=" +
        encodeURIComponent(message)
      );
    }

    function handleWhatsApp() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      var url = buildWhatsAppSupportUrl();
      if (!url) {
        setStatus("WhatsApp link is not configured.");
        return;
      }
      window.open(url, "_blank", "noopener,noreferrer");
    }

    async function handleShare() {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }
      var contactOk = await ensureContactForExport("share");
      if (!contactOk) {
        return;
      }

      var shareFile = new File([generatedBlob], generatedFilename, { type: "image/jpeg" });
      var shareText = "Try-On Result";
      if (navigator.canShare && navigator.canShare({ files: [shareFile] })) {
        setToolbarActionLoading(true, "Sharing…");
        setStatus("");
        try {
          await navigator.share({
            title: "Try-On Result",
            text: shareText,
            files: [shareFile]
          });
          setStatus("Shared successfully.");
        } catch (error) {
          setStatus("Share cancelled.");
        } finally {
          setToolbarActionLoading(false);
        }
      } else {
        setToolbarActionLoading(true, "Downloading…");
        setStatus("");
        try {
          await nextPaint();
          downloadBlob(generatedBlob, generatedFilename);
          setStatus("Share unsupported. Downloaded instead.");
        } catch (err) {
          setStatus("Download failed.", "error");
          console.error("[TryOn] Download error:", err);
        } finally {
          setToolbarActionLoading(false);
        }
      }
    }

    function getDailyGenerationLimit() {
      var raw = parseInt(modal.dataset.tryonDailyGenerationLimit, 10);
      return !isNaN(raw) && raw > 0 ? raw : 3;
    }

    function hasReachedDailyGenerationLimit(state) {
      state = state || readDailyState();
      return (state.generationAttempts || 0) >= getDailyGenerationLimit();
    }

    function updateGenerationLimitUi() {
      var atLimit = hasReachedDailyGenerationLimit();
      if (regenerateButton) {
        regenerateButton.disabled = atLimit;
        if (atLimit) {
          regenerateButton.setAttribute(
            "title",
            "Daily try-on limit reached (" + getDailyGenerationLimit() + "). Try again tomorrow."
          );
        } else {
          regenerateButton.removeAttribute("title");
        }
      }
    }

    /**
     * First result can be generated without details.
     * Download and share on that result ask for details first.
     * A later try-on the same day also asks if details were never saved.
     */
    async function ensureContactForExport(actionLabel) {
      var state = readDailyState();
      if (state.contactSubmitted) {
        return true;
      }
      var details = await askCustomerDetails(actionLabel);
      if (!details) {
        setStatus("Contact details are required to download or share.");
        return false;
      }
      return true;
    }

    async function ensureContactForTryOn(statusMessage) {
      var state = readDailyState();
      if (state.contactSubmitted) {
        return true;
      }
      if ((state.generationAttempts || 0) < 1) {
        return true;
      }
      var details = await askCustomerDetails("generate");
      if (!details) {
        setStatus("Contact details are required for another try-on.");
        return false;
      }
      setStatus(statusMessage || "Generating try-on result...");
      return true;
    }

    async function requestGeneration(fileBlob, options) {
      options = options || {};
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      var stateBefore = readDailyState();
      if (hasReachedDailyGenerationLimit(stateBefore)) {
        setStatus(
          "You can try on up to " +
            getDailyGenerationLimit() +
            " times per day. Please try again tomorrow.",
          "error"
        );
        updateGenerationLimitUi();
        return;
      }
      var wasContactSubmittedBefore = stateBefore.contactSubmitted === true;
      var contactOk = await ensureContactForTryOn(options.statusMessage);
      if (!contactOk) {
        return;
      }
      recordGenerationAttempt();
      if (wasContactSubmittedBefore) {
        try {
          await submitStoredContactForCurrentProduct();
        } catch (sheetErr) {
          console.error("[TryOn] Sheet save:", sheetErr);
        }
      }
      await sendToApi(fileBlob);
    }

    async function sendToApi(fileBlob) {
      var endpoint = modal.dataset.apiEndpoint;
      var apiKey = modal.dataset.apiKey || modal.dataset.apiAuth;
      if (!endpoint) {
        setStatus("API endpoint missing.");
        return;
      }
      if (!apiKey) {
        setStatus("API key missing.");
        return;
      }

      var garmentUrl = syncGarmentImage();
      if (!garmentUrl) {
        setStatus("Garment image missing.");
        return;
      }

      setStatus("Preparing images...");
      setLoading(true);
      var personEncoded;
      var garmentEncoded;
      try {
        personEncoded = await blobToJpegBase64(fileBlob);
        garmentEncoded = await imageUrlToJpegBase64(garmentUrl);
      } catch (prepErr) {
        setLoading(false);
        setStatus(
          (prepErr && prepErr.message) || "Could not prepare images for try-on.",
          "error"
        );
        console.error("[TryOn] Image prep error:", prepErr);
        return;
      }

      if (!personEncoded.base64 || !garmentEncoded.base64) {
        setLoading(false);
        setStatus("Could not prepare model or garment image.", "error");
        return;
      }

      var resolution = String(modal.dataset.tryonResolution || "1K").trim().toUpperCase();
      if (resolution !== "1K" && resolution !== "2K" && resolution !== "4K") {
        resolution = "1K";
      }

      var payload = {
        personImage: personEncoded.base64,
        garmentMimeType: garmentEncoded.mimeType || "image/jpeg",
        garmentImage: garmentEncoded.base64,
        resolution: resolution
      };

      setStatus("Generating try-on result...");
      var abortController = new AbortController();
      var abortTimer = setTimeout(function () { abortController.abort(); }, 600000);
      try {
        var response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": apiKey
          },
          body: JSON.stringify(payload),
          signal: abortController.signal
        });
        clearTimeout(abortTimer);

        var errBodyText = "";
        if (!response.ok) {
          try {
            errBodyText = await response.text();
          } catch (readErr) {
            console.warn("[TryOn] Could not read API error body:", readErr);
          }
          var errJson = null;
          if (errBodyText) {
            try {
              errJson = JSON.parse(errBodyText);
            } catch (parseErr) {
              /* use raw body text below */
            }
          }
          var errMsg = extractTryonApiErrorMessage(errJson, errBodyText, response.status);
          console.warn("[TryOn] API HTTP error:", response.status, errMsg, errBodyText || errJson);
          throw new Error(errMsg);
        }

        var apiResultBlob = await parseTryonSuccessResponse(response);
        if (!apiResultBlob) {
          throw new Error("No result image in API response.");
        }
        var finalBlob = await applyWatermark(apiResultBlob);
        generatedBlob = finalBlob;
        generatedFilename = "try-on-" + Date.now() + ".jpg";
        resultImage.src = URL.createObjectURL(finalBlob);
        setUploadState("result");
        setStatus("Try-on ready.");
        incrementSuccessfulGenerationCount();
        updateGenerationLimitUi();
      } catch (error) {
        clearTimeout(abortTimer);
        var msg =
          error && error.name === "AbortError"
            ? "Request timed out after 10 minutes. Please retry."
            : (error && error.message && String(error.message).trim()) ||
              "Try-on failed. Please retry.";
        setStatus(msg, "error");
        console.error("[TryOn] Try-on error:", msg, error);
      } finally {
        setLoading(false);
      }
    }

    function waitForVideoFrameReady(v, maxMs) {
      maxMs = maxMs || 500;
      if (v.videoWidth >= 2 && v.videoHeight >= 2 && v.readyState >= 2) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var finished = false;
        function done() {
          if (finished) {
            return;
          }
          finished = true;
          v.removeEventListener("loadeddata", onReady);
          v.removeEventListener("canplay", onReady);
          v.removeEventListener("resize", onReady);
          clearTimeout(tid);
          resolve();
        }
        function onReady() {
          if (v.videoWidth >= 2 && v.videoHeight >= 2) {
            done();
          }
        }
        v.addEventListener("loadeddata", onReady);
        v.addEventListener("canplay", onReady);
        v.addEventListener("resize", onReady);
        var tid = setTimeout(done, maxMs);
      });
    }

    function waitNextVideoFrame(el) {
      return new Promise(function (resolve) {
        if (!el) {
          resolve();
          return;
        }
        if (typeof el.requestVideoFrameCallback === "function") {
          el.requestVideoFrameCallback(function () {
            resolve();
          });
        } else {
          requestAnimationFrame(function () {
            resolve();
          });
        }
      });
    }

    async function ensureVideoPlaying(v) {
      if (!v) {
        return;
      }
      try {
        if (v.paused) {
          await v.play();
        }
      } catch (playErr) {
        /* stream already playing in most cases */
      }
    }

    async function captureFromCamera() {
      if (!video || !canvas) {
        return;
      }

      await ensureVideoPlaying(video);

      var maxAttempts = cameraFacingMode === "environment" ? 5 : 3;
      var width = 0;
      var height = 0;
      var a = 0;
      for (a = 0; a < maxAttempts; a++) {
        try {
          await waitForVideoFrameReady(video, 1000);
        } catch (waitErr) {
          /* continue */
        }
        await ensureVideoPlaying(video);
        await waitNextVideoFrame(video);
        await waitNextVideoFrame(video);
        width = video.videoWidth || 0;
        height = video.videoHeight || 0;
        if (width >= 2 && height >= 2) {
          break;
        }
        await new Promise(function (r) {
          setTimeout(r, 180 + a * 120);
        });
      }

      if (width < 2 || height < 2) {
        setStatus("Could not read camera frame. Tap Camera to retry or use Choose Photo.");
        return;
      }
      var crop = getCaptureCrop(width, height);
      var targetSize = getTargetCaptureSize();
      canvas.width = targetSize.width;
      canvas.height = targetSize.height;
      var context = canvas.getContext("2d");
      context.drawImage(video, crop.sx, crop.sy, crop.sw, crop.sh, 0, 0, targetSize.width, targetSize.height);

      var blob = await new Promise(function (resolve) {
        canvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
      });

      if (!blob) {
        setStatus("Could not capture image.");
        return;
      }

      stopCamera();
      lastSourceBlob = blob;
      previewImage.src = URL.createObjectURL(blob);
      setUploadState("preview");
      setStatus("Captured. Sending to try-on...");
      requestGeneration(blob);
    }

    async function startCameraAndAutoCapture() {
      stopCamera();
      cameraFacingMode = "user";
      syncGarmentImage();
      setStatus("Requesting camera permission...");

      try {
        await attachLiveCameraStream();
        setUploadState("camera");
        setStatus("Stand in middle for accurate outputs.");
        setCameraInstruction("Stand in middle for accurate outputs.");
      } catch (error) {
        setStatus("Camera permission denied or unavailable.");
      }
    }

    async function flipCameraFacing(event) {
      if (event) {
        event.stopPropagation();
      }
      if (currentState !== "camera" || isLoading || !stream || !video) {
        return;
      }
      var previousMode = cameraFacingMode;
      cameraFacingMode = previousMode === "user" ? "environment" : "user";
      setStatus("Switching camera…");
      try {
        if (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          stream = null;
        }
        await attachLiveCameraStream();
        setStatus("Stand in middle for accurate outputs.");
        setCameraInstruction("Stand in middle for accurate outputs.");
      } catch (err) {
        cameraFacingMode = previousMode;
        try {
          await attachLiveCameraStream();
          setStatus("Stand in middle for accurate outputs.");
          setCameraInstruction("Stand in middle for accurate outputs.");
        } catch (err2) {
          setStatus("Could not switch camera. Try again.", "error");
          console.warn("[TryOn] Flip camera failed:", err, err2);
        }
      }
    }

    function openModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      var openTrigger = event && event.currentTarget ? event.currentTarget : null;
      var selectedVariantId = getSelectedVariantIdFromForm();
      if (selectedVariantId) {
        modal.setAttribute("data-tryon-variant-id", String(selectedVariantId));
        var productPath = String(modal.dataset.tryonProductPath || window.location.pathname || "").trim();
        var storeOrigin = getTryonStoreOrigin() || String(modal.dataset.tryonWebsiteUrl || "").replace(/\/$/, "");
        if (storeOrigin && productPath) {
          modal.dataset.tryonProductUrl =
            storeOrigin + productPath + (productPath.indexOf("?") === -1 ? "?" : "&") + "variant=" + selectedVariantId;
        }
      }
      syncGarmentImage(openTrigger);
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("overflow-hidden");
      if (!contextMenuBlocker) {
        contextMenuBlocker = function (event) {
          if (modal.classList.contains("is-open")) {
            event.preventDefault();
          }
        };
      }
      document.addEventListener("contextmenu", contextMenuBlocker);
      setUploadState("empty");
      setLoading(false);
      setToolbarActionLoading(false);
      updateGenerationLimitUi();
      cameraFacingMode = "user";
      setStatus("Choose camera or upload to start try-on.");
      previewImage.src = "";
      resultImage.src = "";
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.classList.remove("ss-tryon-modal--details-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("overflow-hidden");
      if (contextMenuBlocker) {
        document.removeEventListener("contextmenu", contextMenuBlocker);
      }
      if (detailsModal) {
        detailsModal.hidden = true;
      }
      setToolbarActionLoading(false);
      stopCamera();
    }

    if (!window.__ssTryOnOpenByInstance) {
      window.__ssTryOnOpenByInstance = Object.create(null);
    }
    if (instanceId) {
      window.__ssTryOnOpenByInstance[instanceId] = openModal;
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    cameraButton.addEventListener("click", startCameraAndAutoCapture);
    function handleManualCapture(event) {
      if (event) {
        event.stopPropagation();
      }
      if (currentState !== "camera" || isCameraCaptureInProgress || isLoading) {
        return;
      }
      isCameraCaptureInProgress = true;
      captureFromCamera().finally(function () {
        isCameraCaptureInProgress = false;
      });
    }

    if (captureButton) {
      captureButton.addEventListener("click", handleManualCapture);
    }
    chooseButton.addEventListener("click", function () {
      fileInput.click();
    });

    uploadBox.addEventListener("click", function (event) {
      if (event.target && event.target.closest(".ss-tryon-toolbar-stack")) {
        return;
      }
      if (event.target && event.target.closest(".ss-tryon-camera-flip-row")) {
        return;
      }
      if (detailsModal && !detailsModal.hidden) {
        return;
      }
      if (currentState !== "camera") {
        fileInput.click();
      }
    });

    fileInput.addEventListener("change", function (event) {
      var file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      stopCamera();
      var objectUrl = URL.createObjectURL(file);
      previewImage.src = objectUrl;
      setUploadState("preview");

      var img = new Image();
      img.onload = function () {
        lastSourceBlob = file;
        setStatus("Uploading selected photo...");
        requestGeneration(file);
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        previewImage.src = "";
        lastSourceBlob = null;
        setUploadState("empty");
        setStatus("Could not read that image. Please try another file.", "error");
        fileInput.value = "";
      };
      img.src = objectUrl;
    });

    regenerateButton.addEventListener("click", function () {
      if (isLoading || isToolbarActionBusy) {
        return;
      }
      if (!lastSourceBlob) {
        setStatus("Capture or upload first, then regenerate.");
        return;
      }
      requestGeneration(lastSourceBlob, { statusMessage: "Regenerating..." });
    });

        [shareButton, downloadButton, whatsappButton, regenerateButton, cameraFlipButton, captureButton].forEach(function (button) {
      if (!button) {
        return;
      }
      button.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });

    if (cameraFlipButton) {
      cameraFlipButton.addEventListener("click", flipCameraFacing);
    }

    downloadButton.addEventListener("click", handleDownload);
    shareButton.addEventListener("click", handleShare);
    if (whatsappButton) {
      whatsappButton.addEventListener("click", handleWhatsApp);
    }

    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("theme:variant:change", function (event) {
      if (event && event.detail && event.detail.variant) {
        applyVariantToTryOn(event.detail.variant);
      }
      syncGarmentImage();
    });

    // Belle triggers variant changes as jQuery events, which native listeners never receive.
    if (window.jQuery) {
      window.jQuery(document).on("variantChange", function (event) {
        if (event && event.variant) {
          applyVariantToTryOn(event.variant);
        }
        syncGarmentImage();
      });
    }

    root.dataset.tryonReady = "true";
  }

  function getGalleryTryOnOpenButton() {
    var gallery = document.querySelector("[data-js-product-gallery][data-tryon-gallery-inline='true']");
    var wrap = getGalleryTryOnButtonWrap(gallery);
    if (wrap) {
      var fromWrap = wrap.querySelector("[data-tryon-open]");
      if (fromWrap) {
        return fromWrap;
      }
    }
    return (
      document.querySelector(".try-on-gallery-button[data-tryon-open]") ||
      document.querySelector(".product-page-gallery .ss-tryon-media-btn[data-tryon-open]")
    );
  }

  function isGalleryTryOnTarget(node) {
    return !!(
      node &&
      node.closest &&
      node.closest(
        ".ss-tryon-media-actions, .ss-tryon-media-btn[data-tryon-open], .try-on-gallery-button, .try-on-gallery-button-wrap, [data-tryon-gallery-floating-overlay]"
      )
    );
  }

  function getActiveFotoramaZoomImage() {
    return document.querySelector(
      ".product-page-gallery__main .fotorama__stage__frame.fotorama__active .fotorama__img:not(.fotorama__img--full)"
    );
  }

  function getElevateZoomInstance() {
    if (!window.jQuery) {
      return null;
    }
    var img = getActiveFotoramaZoomImage();
    var ez = img ? window.jQuery(img).data("elevateZoom") : null;
    if (ez) {
      return ez;
    }
    var main = document.querySelector(".product-page-gallery__main");
    if (!main) {
      return null;
    }
    var imgs = main.querySelectorAll(".fotorama__img");
    var i;
    for (i = 0; i < imgs.length; i++) {
      ez = window.jQuery(imgs[i]).data("elevateZoom");
      if (ez) {
        return ez;
      }
    }
    return null;
  }

  function getTryOnGalleryOverlayHost(gallery) {
    if (!gallery) {
      return document.querySelector(".product-page-gallery__main");
    }
    return (
      gallery.querySelector(".product-page-gallery__main") ||
      gallery.querySelector("[data-js-product-gallery-main]") ||
      gallery
    );
  }

  /**
   * Inner elevateZoom lives in [data-js-product-gallery-zoom] (z-index 8), above Fotorama (z-index 1).
   * Hovering Try-On inside the frame never leaves that overlay, so zoom stays open.
   * Call the plugin's own hide path (same as mouseleave on .zoomContainer).
   */
  function triggerProductGalleryElevateZoomLeave() {
    if (!window.jQuery) {
      return;
    }
    var ez = getElevateZoomInstance();
    if (ez) {
      ez.scrollLock = false;
      if (ez.loop) {
        clearInterval(ez.loop);
        ez.loop = false;
      }
      if (typeof ez.setElements === "function") {
        ez.setElements("hide");
      }
      if (typeof ez.showHideWindow === "function") {
        ez.showHideWindow("hide");
      }
      ez.isWindowActive = false;
      if (ez.zoomWindow && ez.zoomWindow.stop) {
        ez.zoomWindow.stop(true, true).hide();
      }
      if (ez.zoomLens && ez.zoomLens.hide) {
        ez.zoomLens.hide();
      }
    }
    var img = getActiveFotoramaZoomImage();
    if (img) {
      window.jQuery(img).trigger("mouseleave");
    }
    if (ez && ez.zoomContainer && ez.zoomContainer.trigger) {
      ez.zoomContainer.trigger("mouseleave");
    }
  }

  function getVisibleTryOnGalleryButtonWrap() {
    var gallery = document.querySelector("[data-js-product-gallery]");
    var wrap =
      (gallery && gallery.__tryonGalleryButtonWrap) ||
      document.querySelector(".product-page-gallery .try-on-gallery-button-wrap");
    if (!wrap) {
      return null;
    }
    var cs = window.getComputedStyle(wrap);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") {
      return null;
    }
    var rect = wrap.getBoundingClientRect();
    if (rect.width < 4 || rect.height < 4) {
      return null;
    }
    return wrap;
  }

  function setGravizoomHidden(btn, hidden) {
    var crop = btn && btn.closest ? btn.closest(".rondell-item-crop") : null;
    var scope = crop || document;
    scope.querySelectorAll(".gravizoomImg").forEach(function (img) {
      if (hidden) {
        img.style.setProperty("opacity", "0", "important");
      } else {
        img.style.removeProperty("opacity");
      }
    });
  }

  function bindTryOnGalleryButtonElevateLeave(btn) {
    if (!btn || btn.dataset.tryonElevateLeaveBound === "true") {
      return;
    }
    btn.dataset.tryonElevateLeaveBound = "true";
    var hovering = false;
    var hideZoom = function () {
      hovering = true;
      triggerProductGalleryElevateZoomLeave();
      setGravizoomHidden(btn, true);
      requestAnimationFrame(function () {
        if (hovering) {
          setGravizoomHidden(btn, true);
        }
      });
    };
    var releaseZoom = function () {
      hovering = false;
      setGravizoomHidden(btn, false);
    };
    btn.addEventListener("mouseenter", hideZoom);
    btn.addEventListener("pointerenter", hideZoom);
    btn.addEventListener("mouseover", hideZoom);
    btn.addEventListener("mousemove", hideZoom);
    btn.addEventListener("mouseleave", releaseZoom);
    btn.addEventListener("pointerleave", releaseZoom);
  }

  function bindTryOnGalleryHostElevateLeave(host) {
    if (!host || host.dataset.tryonHostZoomLeaveBound === "true") {
      return;
    }
    host.dataset.tryonHostZoomLeaveBound = "true";
    host.addEventListener(
      "mouseover",
      function (event) {
        if (
          event.target &&
          event.target.closest &&
          event.target.closest(".try-on-gallery-button, [data-tryon-open]")
        ) {
          triggerProductGalleryElevateZoomLeave();
        }
      },
      true
    );
  }

  function getProductGalleryTryOnActions() {
    var btn = document.querySelector(".ss-tryon-media-btn[data-tryon-open]");
    return btn ? btn.closest(".ss-tryon-media-actions") : null;
  }

  function getProductTryOnScope(gallery) {
    if (gallery && gallery.closest) {
      var fromGallery = gallery.closest("[data-js-product]");
      if (fromGallery) {
        return fromGallery;
      }
    }
    return document.querySelector("[data-js-product]") || document.querySelector(".template-product");
  }

  function minTryOnGalleryImageSize() {
    return window.innerWidth < 768 ? 40 : 64;
  }

  function isTryOnGalleryImageCandidate(img) {
    if (!img || img.tagName !== "IMG") {
      return false;
    }
    if (img.classList.contains("fotorama__img--full")) {
      return false;
    }
    if (
      !img.classList.contains("rondell-item-image") &&
      img.closest(
        ".product-page-gallery__collage, .product-page-gallery__preview, .product-page-gallery__thumbnails, .product-page-gallery__sheet"
      )
    ) {
      return false;
    }
    var rect = img.getBoundingClientRect();
    var min = minTryOnGalleryImageSize();
    return rect.width >= min && rect.height >= min;
  }

  function isImageInViewport(rect) {
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function isDisplayedImage(img) {
    var cs = window.getComputedStyle(img);
    if (cs.display === "none" || cs.visibility === "hidden") {
      return false;
    }
    if (parseFloat(cs.opacity) < 0.05) {
      return false;
    }
    return true;
  }

  function considerMainProductImage(img, best) {
    if (!isTryOnGalleryImageCandidate(img) || !isDisplayedImage(img)) {
      return best;
    }
    var rect = img.getBoundingClientRect();
    if (!isImageInViewport(rect)) {
      return best;
    }
    var area = rect.width * rect.height;
    if (!best || area > best.area) {
      return { img: img, area: area, rect: rect };
    }
    return best;
  }

  function getTryOnImageSearchRoots(gallery) {
    var roots = [];
    var seen = {};
    function add(root) {
      if (root && !seen[root]) {
        seen[root] = true;
        roots.push(root);
      }
    }
    add(document.querySelector("#MainContent"));
    add(document.querySelector(".template-product"));
    add(getProductTryOnScope(gallery));
    add(document.querySelector("[data-js-product]"));
    add(gallery);
    return roots;
  }

  function getVisibleMainProductImage(gallery) {
    var roots = getTryOnImageSearchRoots(gallery);
    var best = null;
    var rondellSelectors = [
      "img.rondell-item-image",
      "[class*='rondell'] img.rondell-item-image",
      "[class*='rondell'] img"
    ];
    var fotoramaSelectors = [
      ".fotorama__stage__frame.fotorama__active .fotorama__img:not(.fotorama__img--full)",
      ".fotorama__stage__frame.fotorama__active img",
      ".fotorama__active .fotorama__img:not(.fotorama__img--full)",
      ".fotorama__active img"
    ];
    var s;
    var nodes;
    var i;
    var n;
    var r;

    for (r = 0; r < roots.length; r++) {
      for (s = 0; s < rondellSelectors.length; s++) {
        nodes = roots[r].querySelectorAll(rondellSelectors[s]);
        for (n = 0; n < nodes.length; n++) {
          best = considerMainProductImage(nodes[n], best);
        }
      }
    }

    if (gallery) {
      for (s = 0; s < fotoramaSelectors.length; s++) {
        best = considerMainProductImage(gallery.querySelector(fotoramaSelectors[s]), best);
      }
      var main = gallery.querySelector("[data-js-product-gallery-main]");
      if (main) {
        nodes = main.querySelectorAll("img");
        for (i = 0; i < nodes.length; i++) {
          best = considerMainProductImage(nodes[i], best);
        }
      }
    }

    return best ? best.img : null;
  }

  function getTryOnImageMountHost(img) {
    if (!img) {
      return null;
    }
    return (
      img.closest(".fotorama__stage__frame.fotorama__active") ||
      img.closest(".fotorama__wrap") ||
      img.closest(".fotorama__stage") ||
      img.closest("[class*='rondell-item']") ||
      img.closest("[class*='rondell']") ||
      img.parentElement
    );
  }

  function pinTryOnOnProductImage(actions, btn, img, inset) {
    var imgRect = img.getBoundingClientRect();
    if (imgRect.width < minTryOnGalleryImageSize()) {
      return false;
    }

    var host = getTryOnImageMountHost(img);
    if (!host) {
      applyGalleryTryOnFixedPin(actions, btn, imgRect, inset);
      return true;
    }

    if (window.getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }
    if (actions.parentElement !== host) {
      host.appendChild(actions);
    }

    var hostRect = host.getBoundingClientRect();
    actions.classList.remove("ss-tryon-media-actions--pinned");
    actions.classList.add("ss-tryon-media-actions--on-image");
    actions.style.position = "absolute";
    actions.style.top = Math.max(0, Math.round(imgRect.top - hostRect.top + inset)) + "px";
    actions.style.left = Math.round(imgRect.right - hostRect.left - inset) + "px";
    actions.style.right = "auto";
    actions.style.bottom = "auto";
    actions.style.transform = "translateX(-100%)";
    actions.style.zIndex = "2147482000";
    styleGalleryTryOnActions(actions, btn);

    if (btn) {
      var btnRect = btn.getBoundingClientRect();
      if (btnRect.width >= 10 && btnRect.height >= 10) {
        return true;
      }
    }

    applyGalleryTryOnFixedPin(actions, btn, imgRect, inset);
    return true;
  }

  function styleGalleryTryOnActions(actions, btn) {
    actions.style.visibility = "visible";
    actions.style.opacity = "1";
    actions.style.display = "flex";
    actions.style.width = "auto";
    actions.style.height = "auto";
    actions.style.minHeight = "34px";
    actions.style.pointerEvents = "none";
    if (btn) {
      btn.style.pointerEvents = "auto";
      btn.style.display = "inline-flex";
      btn.style.visibility = "visible";
      btn.style.opacity = "1";
      btn.style.minWidth = "72px";
      btn.style.minHeight = "34px";
      btn.style.width = "auto";
      btn.style.height = "auto";
    }
  }

  function applyGalleryTryOnFixedPin(actions, btn, rect, inset) {
    if (actions.parentElement !== document.body) {
      document.body.appendChild(actions);
    }

    actions.classList.remove("ss-tryon-media-actions--on-image");
    actions.classList.add("ss-tryon-media-actions--pinned");
    actions.style.position = "fixed";
    actions.style.top = Math.max(0, Math.round(rect.top + inset)) + "px";
    actions.style.left = Math.round(rect.right - inset) + "px";
    actions.style.right = "auto";
    actions.style.bottom = "auto";
    actions.style.transform = "translateX(-100%)";
    actions.style.zIndex = "2147482000";
    styleGalleryTryOnActions(actions, btn);
  }

  function mountGalleryTryOnAbsolute(actions, btn, host, inset) {
    if (!host.contains(actions)) {
      host.appendChild(actions);
    }
    actions.classList.remove("ss-tryon-media-actions--pinned", "ss-tryon-media-actions--on-image");
    actions.style.position = "absolute";
    actions.style.top = inset + "px";
    actions.style.right = inset + "px";
    actions.style.left = "auto";
    actions.style.bottom = "auto";
    actions.style.transform = "none";
    actions.style.zIndex = "1000";
    styleGalleryTryOnActions(actions, btn);
  }

  function galleryTryOnCornerInset() {
    return window.innerWidth < 768 ? 10 : 10;
  }

  function getGalleryTryOnAnchorRect(gallery) {
    var inset = galleryTryOnCornerInset();
    var img = getVisibleMainProductImage(gallery);
    if (!img && gallery) {
      img =
        gallery.querySelector(".fotorama__stage__frame.fotorama__active .fotorama__img:not(.fotorama__img--full)") ||
        gallery.querySelector(".fotorama__stage__frame.fotorama__active img");
    }
    if (!img) {
      var scope = getProductTryOnScope(gallery) || document;
      var rondellImgs = scope.querySelectorAll("img.rondell-item-image");
      var i;
      var bestArea = 0;
      for (i = 0; i < rondellImgs.length; i++) {
        var r = rondellImgs[i].getBoundingClientRect();
        var area = r.width * r.height;
        if (r.width >= 40 && r.height >= 40 && area > bestArea) {
          bestArea = area;
          img = rondellImgs[i];
        }
      }
    }
    if (img) {
      var imgRect = img.getBoundingClientRect();
      if (imgRect.width >= 40 && imgRect.height >= 40) {
        return { top: imgRect.top + inset, left: imgRect.right - inset, inset: inset };
      }
    }
    var stage =
      (gallery && gallery.querySelector(".product-page-gallery__main")) ||
      document.querySelector(".product-page-gallery__main");
    if (stage) {
      var stageRect = stage.getBoundingClientRect();
      if (stageRect.width >= 40 && stageRect.height >= 40) {
        return { top: stageRect.top + inset, left: stageRect.right - inset, inset: inset };
      }
    }
    var productRoot = getProductTryOnScope(gallery);
    if (productRoot) {
      var rootRect = productRoot.getBoundingClientRect();
      if (rootRect.width >= 40) {
        return { top: rootRect.top + inset + 80, left: rootRect.right - inset, inset: inset };
      }
    }
    return null;
  }

  function styleGalleryImageTryOnWrap(wrap) {
    if (!wrap) {
      return;
    }
    wrap.style.position = "absolute";
    wrap.style.left = "auto";
    wrap.style.bottom = "auto";
    wrap.style.zIndex = "10050";
    wrap.style.pointerEvents = "none";
    wrap.style.display = "flex";
    wrap.style.visibility = "visible";
    wrap.style.opacity = "1";
    var btn = wrap.querySelector(".try-on-gallery-button, [data-tryon-open]");
    if (btn) {
      btn.style.pointerEvents = "auto";
      btn.style.display = "inline-flex";
      btn.style.visibility = "visible";
      btn.style.opacity = "1";
      bindTryOnGalleryButtonElevateLeave(btn);
    }
  }

  function isTryOnThumbnailContext(node) {
    if (!node || !node.closest) {
      return false;
    }
    if (
      node.closest(
        ".product-page-gallery__thumbnails, .product-page-gallery__preview, .product-page-gallery__collage, .product-page-gallery__sheet, [class*='rondell-thumb'], [class*='thumbnail'], .rondell-thumbnails, .rondell-controls"
      )
    ) {
      return true;
    }
    var rondellItem = node.closest("a.rondell-item, .rondell-item");
    if (rondellItem && !rondellItem.classList.contains("rondell-item-focused")) {
      return true;
    }
    return false;
  }

  function getActiveRondellFocusedImage(scope) {
    if (!scope) {
      return null;
    }
    var focusedImg = scope.querySelector(
      "a.rondell-item-focused img.rondell-item-image, .rondell-item-focused img.rondell-item-image"
    );
    if (!focusedImg) {
      return null;
    }
    var rect = focusedImg.getBoundingClientRect();
    if (rect.width >= 40 && rect.height >= 40) {
      return focusedImg;
    }
    return null;
  }

  function getActiveMainGalleryImage(gallery) {
    if (!gallery) {
      return null;
    }

    var scope = getProductTryOnScope(gallery) || gallery;
    var rondellFocused = getActiveRondellFocusedImage(scope);
    if (rondellFocused) {
      return rondellFocused;
    }

    var fotoramaImg =
      gallery.querySelector(".fotorama__stage__frame.fotorama__active .fotorama__img:not(.fotorama__img--full)") ||
      gallery.querySelector(".fotorama__stage__frame.fotorama__active img");
    if (fotoramaImg) {
      var fRect = fotoramaImg.getBoundingClientRect();
      if (fRect.width >= 40 && fRect.height >= 40 && !isTryOnThumbnailContext(fotoramaImg)) {
        return fotoramaImg;
      }
    }

    var rondellImgs = scope.querySelectorAll("img.rondell-item-image");
    var minMainWidth = Math.max(140, Math.round(window.innerWidth * 0.42));
    var best = null;
    var bestArea = 0;
    var i;
    for (i = 0; i < rondellImgs.length; i++) {
      if (isTryOnThumbnailContext(rondellImgs[i])) {
        continue;
      }
      var rect = rondellImgs[i].getBoundingClientRect();
      if (rect.width < minMainWidth || rect.height < 80) {
        continue;
      }
      if (!isImageInViewport(rect)) {
        continue;
      }
      var area = rect.width * rect.height;
      if (area > bestArea) {
        bestArea = area;
        best = rondellImgs[i];
      }
    }
    if (best) {
      return best;
    }

    return getVisibleMainProductImage(gallery);
  }

  function getGalleryImageTryOnHost(img, gallery) {
    if (!img) {
      return gallery.querySelector(".product-page-gallery__main") || gallery;
    }
    var focusedCard = img.closest("a.rondell-item-focused, .rondell-item-focused");
    if (focusedCard) {
      return focusedCard.querySelector(".rondell-item-crop") || focusedCard;
    }
    var host =
      img.closest("a.rondell-item") ||
      img.closest(".fotorama__stage__frame") ||
      img.closest(".try-on-gallery-image") ||
      img.parentElement;
    if (!host || isTryOnThumbnailContext(host)) {
      host = gallery.querySelector(".product-page-gallery__main") || gallery;
    }
    return host;
  }

  function mountTryOnWrapOnGalleryHost(sourceWrap, host, inset, alignImg) {
    if (!sourceWrap || !host) {
      return;
    }
    var rondellCard = host.closest ? host.closest("a.rondell-item, .rondell-item") : null;
    if (rondellCard && !rondellCard.classList.contains("rondell-item-focused")) {
      sourceWrap.style.display = "none";
      return;
    }
    if (window.getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }
    if (!host.contains(sourceWrap)) {
      host.appendChild(sourceWrap);
    }
    var gap = inset != null ? inset : galleryTryOnCornerInset();
    sourceWrap.style.position = "absolute";
    if (alignImg && alignImg.getBoundingClientRect) {
      var hostRect = host.getBoundingClientRect();
      var imgRect = alignImg.getBoundingClientRect();
      sourceWrap.style.top = Math.max(0, Math.round(imgRect.top - hostRect.top + gap)) + "px";
      sourceWrap.style.right = Math.max(0, Math.round(hostRect.right - imgRect.right + gap)) + "px";
    } else {
      sourceWrap.style.top = gap + "px";
      sourceWrap.style.right = gap + "px";
    }
    sourceWrap.style.left = "auto";
    sourceWrap.style.bottom = "auto";
    sourceWrap.style.transform = "none";
    sourceWrap.style.zIndex = "10050";
    sourceWrap.style.display = "flex";
    styleGalleryImageTryOnWrap(sourceWrap);
    bindTryOnGalleryHostElevateLeave(host);
  }

  function getGalleryTryOnButtonWrap(gallery) {
    if (gallery && gallery.__tryonGalleryButtonWrap) {
      return gallery.__tryonGalleryButtonWrap;
    }
    var wrap =
      (gallery && gallery.querySelector(".try-on-gallery-button-wrap")) ||
      document.querySelector(".product-page-gallery .try-on-gallery-button-wrap");
    if (wrap && gallery) {
      gallery.__tryonGalleryButtonWrap = wrap;
    }
    return wrap || null;
  }

  function syncInlineGalleryTryOnOverlay() {
    var gallery = document.querySelector("[data-js-product-gallery]");
    if (!gallery || gallery.getAttribute("data-tryon-gallery-inline") !== "true") {
      return;
    }

    var sourceWrap = getGalleryTryOnButtonWrap(gallery);
    if (!sourceWrap) {
      return;
    }
    document.querySelectorAll(".try-on-gallery-button-wrap").forEach(function (wrap) {
      if (wrap !== sourceWrap) {
        wrap.style.display = "none";
      }
    });

    var scope = getProductTryOnScope(gallery) || gallery;
    var inset = galleryTryOnCornerInset();
    var overlayHost = getTryOnGalleryOverlayHost(gallery);
    var rondellFocusedImg = getActiveRondellFocusedImage(scope);
    if (rondellFocusedImg) {
      var rondellMediaId = findMediaIdForImageSrc(rondellFocusedImg.currentSrc || rondellFocusedImg.src);
      if (rondellMediaId) {
        gallery.setAttribute("data-tryon-active-media-id", rondellMediaId);
      } else {
        gallery.removeAttribute("data-tryon-active-media-id");
      }
      var rondellHost = getGalleryImageTryOnHost(rondellFocusedImg, gallery);
      mountTryOnWrapOnGalleryHost(sourceWrap, rondellHost, inset, rondellFocusedImg);
      return;
    }

    var activeImg = getActiveMainGalleryImage(gallery);
    if (!activeImg) {
      sourceWrap.style.display = "none";
      return;
    }

    var imgRect = activeImg.getBoundingClientRect();
    if (imgRect.width < 40 || imgRect.height < 40) {
      sourceWrap.style.display = "none";
      return;
    }

    var activeFrame = activeImg.closest(".fotorama__stage__frame");
    if (activeFrame && activeFrame.classList.contains("fotorama__active")) {
      var activeSlide = activeFrame.querySelector("[data-tryon-gallery-slide][data-media-id]");
      if (activeSlide) {
        gallery.setAttribute("data-tryon-active-media-id", activeSlide.getAttribute("data-media-id"));
      } else {
        gallery.removeAttribute("data-tryon-active-media-id");
      }
    } else {
      gallery.removeAttribute("data-tryon-active-media-id");
    }

    mountTryOnWrapOnGalleryHost(sourceWrap, overlayHost, inset, activeImg);
  }

  function syncGalleryTryOnButtonPosition() {
    var gallery = document.querySelector("[data-js-product-gallery]");
    if (gallery && gallery.getAttribute("data-tryon-gallery-inline") === "true") {
      syncInlineGalleryTryOnOverlay();
      return;
    }
    var actions = getProductGalleryTryOnActions();
    if (!actions) {
      return;
    }

    var btn = actions.querySelector(".ss-tryon-media-btn");
    var img = getVisibleMainProductImage(gallery);
    var stage = gallery
      ? gallery.querySelector(".product-page-gallery__main.ss-tryon-gallery-stage") ||
        gallery.querySelector(".ss-tryon-gallery-stage")
      : null;
    var inset = galleryTryOnCornerInset();

    if (img) {
      pinTryOnOnProductImage(actions, btn, img, inset);
      return;
    }

    if (stage) {
      mountGalleryTryOnAbsolute(actions, btn, stage, inset);
    }
  }

  function bindRondellTryOnHooks() {
    if (window.__tryonRondellBound) {
      return;
    }
    window.__tryonRondellBound = true;
    var schedule = function () {
      requestAnimationFrame(syncGalleryTryOnButtonPosition);
    };
    document.addEventListener(
      "click",
      function (event) {
        if (event.target.closest && event.target.closest("[class*='rondell']")) {
          schedule();
        }
      },
      true
    );
    document.addEventListener("touchend", schedule, true);
    var rondellRoot = document.querySelector("#rondellCarousel, .rondell-container");
    if (rondellRoot && window.MutationObserver) {
      new MutationObserver(schedule).observe(rondellRoot, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true,
        childList: true
      });
    }
  }

  function watchGalleryTryOnFotoramaMount() {
    if (window.__tryonGalleryFotoramaWatchBound || !window.MutationObserver) {
      return;
    }
    window.__tryonGalleryFotoramaWatchBound = true;
    var gallery = document.querySelector("[data-js-product-gallery]");
    if (!gallery) {
      return;
    }
    var queued = false;
    var schedule = function () {
      if (queued) {
        return;
      }
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncGalleryTryOnButtonPosition();
      });
    };
    new MutationObserver(schedule).observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "src", "style"]
    });
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  function bindGalleryTryOnFotoramaHooks() {
    if (!window.jQuery) {
      return false;
    }
    var $main = window.jQuery("[data-js-product-gallery-main]");
    if (!$main.length) {
      return false;
    }
    if ($main.data("tryonGallerySyncBound")) {
      return true;
    }
    $main.data("tryonGallerySyncBound", 1);
    $main.on("fotorama:load fotorama:show fotorama:showend", function () {
      syncGalleryTryOnButtonPosition();
    });
    return true;
  }

  function bindGalleryTryOnViewportSync() {
    if (window.__tryonGalleryViewportSyncBound) {
      return;
    }
    window.__tryonGalleryViewportSyncBound = true;
    var queued = false;
    var schedule = function () {
      if (queued) {
        return;
      }
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncGalleryTryOnButtonPosition();
      });
    };
    window.addEventListener("resize", schedule);
    window.addEventListener("scroll", schedule, true);
    window.addEventListener("load", schedule);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", schedule);
      window.visualViewport.addEventListener("scroll", schedule);
    }
  }

  function boot() {
    document.querySelectorAll("[data-tryon-root]").forEach(initTryOn);
    bindGalleryTryOnViewportSync();
    watchGalleryTryOnFotoramaMount();
    bindRondellTryOnHooks();
    syncGalleryTryOnButtonPosition();
    var rondellPoll = setInterval(function () {
      syncGalleryTryOnButtonPosition();
    }, 300);
    setTimeout(function () {
      clearInterval(rondellPoll);
    }, 15000);
    bindGalleryTryOnFotoramaHooks();
    if (window.jQuery) {
      window.jQuery(document).on("fotorama:load fotorama:show", function () {
        syncGalleryTryOnButtonPosition();
      });
    }
    placeFormTryOnAfterWishlist();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      document.querySelectorAll("[data-tryon-root]").forEach(initTryOn);
      syncGalleryTryOnButtonPosition();
      bindGalleryTryOnFotoramaHooks();
      placeFormTryOnAfterWishlist();
      if (tries >= 40) {
        clearInterval(timer);
      }
    }, 500);
  }

  function placeFormTryOnAfterWishlist() {
    var slot = document.querySelector("[data-tryon-form-slot]");
    if (!slot) {
      return;
    }
    var scope =
      slot.closest(".product__submit__holder") ||
      slot.closest(".product__form") ||
      document.querySelector(".product-single .product__submit__holder");
    if (!scope) {
      return;
    }
    var candidates = scope.querySelectorAll(
      'button, a, div, span'
    );
    var wishlistNode = null;
    var i;
    for (i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el === slot || slot.contains(el)) {
        continue;
      }
      var label = (
        (el.getAttribute("aria-label") || "") +
        " " +
        (el.textContent || "") +
        " " +
        (el.className || "") +
        " " +
        (el.id || "")
      ).toLowerCase();
      if (
        label.indexOf("wishlist") !== -1 ||
        label.indexOf("wish list") !== -1 ||
        label.indexOf("nm-wishlist") !== -1
      ) {
        wishlistNode = el.closest(".product__submit__item") || el;
        break;
      }
    }
    if (!wishlistNode || !wishlistNode.parentNode) {
      return;
    }
    if (wishlistNode.nextElementSibling === slot) {
      return;
    }
    if (wishlistNode.parentNode === slot.parentNode) {
      wishlistNode.parentNode.insertBefore(slot, wishlistNode.nextSibling);
      return;
    }
    if (wishlistNode.parentNode) {
      wishlistNode.parentNode.insertBefore(slot, wishlistNode.nextSibling);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
